<template>
    <DefaultHeader />
    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container-fluid">
        <div class="row d-flex justify-content-center">
            <div class="col-11 mb-3 mb-lg-5">
                <div class="card table-nowrap table-card">
                    <div class="table-responsive">
                        <table class="table mb-0 table-striped">
                            <thead class="small text-uppercase bg-body text-muted">
                                <tr>
                                    <th class="align-middle">Nom</th>
                                    <th class="align-middle">Prénom</th>
                                    <th v-if="$isAdmin" class="align-middle"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <TableRow v-for="member in members"
                                :key="member.id"
                                :member="member"
                                @save="updateMember(member.id, $event)" >
                                </TableRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>
    
<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import MissionMemberService from '@/services/missionMember.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import TableRow from './Sections/TableRow.vue'

export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        TableRow,
    },
    data() {
        return {
            members: null
        };
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData() {
            MissionMemberService.getList()
            .then(response => {
                this.members = FormatHelper.missionMembersFormat(response.data);
            })
            .catch(e => {
                console.log(e);
            });
        },
        updateMember(memberId, data) {
            MissionMemberService.update(memberId, data)
            .then(() => {
                this.refreshData();
            })
            .catch(e => {
                console.log(e);
            });
        },
    }
}
</script>